const initBanner = () => {
  const banner = document.querySelector("[data-banner]");
  const formContainer = document.querySelector("[data-form-container]");
  const introBlock = document.querySelector("[data-intro]");
  if (!banner) return;
  const trackScroll = () => {
    const scrolled = window.pageYOffset;
    
    if (scrolled < introBlock.offsetTop + introBlock.clientHeight) {
      banner.style.transform = "translateY(100%)";
    } else if (scrolled + document.documentElement.clientHeight > formContainer.offsetTop) {
      banner.style.transform = "translateY(100%)";
    } else if (scrolled < formContainer.offsetTop) {
      banner.style.transform = "translateY(0)";
    }
  };
  trackScroll();
  window.addEventListener("scroll", trackScroll);
};
 
export default initBanner;
 